import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeAsetService = new CrudCustom('/tipe-asets');
export default TipeAsetService;
